import React from 'react'

import './styles.scss'
import iconChecked from 'assets/images/checkmark-rounded-61CEF7.svg'
import iconUnchecked from 'assets/images/checkbox-gray-0.svg'

import {
	Icon, Checkbox
} from 'components'
// import { AdminUserInfoAlert } from '../user-info-alert'

import { DateHelper } from 'utils'
import moment from 'moment-timezone'
import { WithdrawlLogsInfoAlert } from '../withdrawl-logs-alert'

export function UserListItem({
	user = {},
	isHeader = false,
	selected = false,
	onSelect = (value) => { },
	onRefresh = () => { }
}) {
	const { email, amount, createdAt, updatedAt, status, transactionId, fee, platform, destination, transactionBucket } = user

	const [isOpenInfo, setOpenInfo] = React.useState(false)

	function handleClick() {
		if (isHeader) return

		setOpenInfo(true)
	}

	function renderCreatedAt(date) {
		if (!date) return ''

		return 'Create ' + DateHelper.format(date, 'MM/DD/YYYY')
	}

	return (
		<>
			<div className={`user-list-item ${isHeader && 'header'}`} onClick={() => handleClick()}>
				{isHeader ?
					<>
						<div className="email-email">Email</div>
						<div className="amount">Amount</div>
						<div className="fee">Fee</div>
						<div className="email">Platform</div>
						<div className="email">status</div>
						<div className="email-email">Transaction Id</div>
						<div className="email-email">Destination</div>
						<div className="email">Created</div>
						<div className="email">Updated</div>
					</>
					:
					<>
						<div className="email-email">{email}</div>
						<div className="amount">${amount}</div>
						<div className="fee">${fee ?? 0}</div>
						<div className="email">{platform}</div>
						<div className="email">{status}</div>
						<div className="email-email">{transactionId ?? <>&nbsp;</>}</div>
						<div className="email-email">{destination}</div>
						<div className="email">{moment(createdAt).format('MM/DD/YYYY')}</div>
						<div className="email">{moment(updatedAt).format('MM/DD/YYYY')}</div>

					</>
				}
			</div>
			{isOpenInfo &&
				<WithdrawlLogsInfoAlert
					id={transactionBucket}
					onClose={() => {
						setOpenInfo(false)
					}} />
			}
		</>
	)
}